import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Heart, Instagram, Mail, Phone } from "lucide-react";

export default function Footer() {
  const loc = useLocation();
  if (loc.pathname.startsWith("/admin")) return null;
  return (
    <footer className="bg-cocoa-dark text-cream/90 mt-24">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="font-heading text-3xl text-cream">Caseirinhos</div>
          <div className="font-accent text-rose mt-1 text-xl">feito com amor</div>
          <p className="mt-5 text-cream/70 max-w-md leading-relaxed">
            Salgados e brigadeiros artesanais, preparados em pequenos lotes para que cada bocado seja uma memória doce.
          </p>
        </div>
        <div>
          <div className="text-sm uppercase tracking-widest text-rose mb-4">Navegar</div>
          <ul className="space-y-2 text-cream/80">
            <li><Link to="/" className="hover:text-rose transition-colors">Início</Link></li>
            <li><Link to="/catalogo" className="hover:text-rose transition-colors">Catálogo</Link></li>
            <li><Link to="/sobre" className="hover:text-rose transition-colors">Sobre nós</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-sm uppercase tracking-widest text-rose mb-4">Contacto</div>
          <ul className="space-y-3 text-cream/80 text-sm">
            <li className="flex items-center gap-2"><Mail className="w-4 h-4" /> caseirinhosptt@gmail.com</li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4" /> +351 920 248 910</li>
            <li className="flex items-center gap-2"><Instagram className="w-4 h-4" /> @caseirinhospt</li>
            <li className="flex items-start gap-2 pt-2 border-t border-cream/10 mt-3">
              <span className="text-rose">📍</span>
              <span>Rua António Duarte Caneças, nº 1<br/>2700-069 Amadora</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-cream/10">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 py-6 flex items-center justify-between text-xs text-cream/60">
          <span>© {new Date().getFullYear()} Caseirinhos. Todos os direitos reservados.</span>
          <span className="flex items-center gap-1.5">Feito com <Heart className="w-3 h-3 text-rose fill-rose" /> em Portugal</span>
        </div>
      </div>
    </footer>
  );
}
